module.exports = __webpack_public_path__ + "img/gala-competencies.9d91b80c.svg";